(() => {
  'use strict';
  if (customElements.get('bica-coffee-guide')) return;
  const gramsFromTitle = (title) => {
    const size = title.split('/')[0].trim().replace(/[٠-٩]/g, n => '٠١٢٣٤٥٦٧٨٩'.indexOf(n));
    if (/ربع/.test(size)) return 250;
    if (/نصف|نص كيلو/.test(size)) return 500;
    const n = Number((size.match(/\d+(?:\.\d+)?/) || [])[0]);
    if (/كيلو|\bkg\b/i.test(size)) return (n || 1) * 1000;
    if (/جرام|غرام|\bg\b|\bgrams?\b/i.test(size) && n) return n;
    return null;
  };
  class BicaCoffeeGuide extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.owner = this.closest('product-info') || this.closest('.shopify-section');
      this.advice = { whole: ['بدون طحن', this.dataset.wholeAdvice], filter: ['طحن فلتر', this.dataset.filterAdvice], espresso: ['طحن اسبريسو', this.dataset.espressoAdvice], press: [null, this.dataset.pressAdvice] };
      this.method = this.querySelector('[data-guide-method]');
      this.dose = this.querySelector('[data-guide-dose]');
      this.apply = this.querySelector('[data-guide-apply]');
      this.addEventListener('input', () => this.update(), {signal:this.abort.signal});
      this.apply.addEventListener('click', () => {
        const target = this.grindInput();
        if (target && !target.disabled) { target.click(); this.update(); }
      }, {signal:this.abort.signal});
      this.unsub?.();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (String(data.sectionId) !== this.dataset.section) return;
          this.dataset.variantTitle = data.variant?.title || '';
          this.update();
        });
      }
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.unsub?.(); }
    grindInput() {
      const label = this.advice[this.method.value][0];
      return Array.from(this.owner?.querySelectorAll('variant-selects input[type="radio"]') || []).find(el => el.value === label);
    }
    update() {
      const choice = this.advice[this.method.value];
      this.querySelector('[data-guide-advice]').textContent = choice[1];
      const target = this.grindInput();
      this.apply.hidden = !target || target.disabled || target.checked || target.classList.contains('disabled');
      this.apply.textContent = this.dataset.apply.replace('__GRIND__', choice[0] || '');
      const grams = gramsFromTitle(this.dataset.variantTitle || '');
      const dose = Number(this.dose.value);
      const result = this.querySelector('[data-guide-result]');
      if (!this.dose.validity.valid || !dose) result.textContent = this.dataset.invalid;
      else if (grams) result.textContent = this.dataset.result.replace('__COUNT__', Math.floor(grams / dose)).replace('__WEIGHT__', grams).replace('__DOSE__', dose);
      else result.textContent = this.dataset.unknown;
    }
  }
  customElements.define('bica-coffee-guide', BicaCoffeeGuide);
})();
